import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import sha256 from 'crypto-js/sha256';

function ReviewDisplay() {
    const { t } = useTranslation();

    const apiUrl = process.env.REACT_APP_BACKEND_URL
    const ImageUrl = process.env.REACT_APP_IMAGES_URL
    const frontEndUrl = process.env.REACT_APP_REACT_URL

    let userId = Cookies.get('userId');
    let UserToken = Cookies.get('UserSpecialToken');
    let IdEntreprise = Cookies.get('IdEntreprise');
    let LanguageSelected = Cookies.get('LanguageSelected');

    const [ReviewContent, setReviewContent] = useState([])
    const hashedUserId = sha256((String(userId)));
    const [ReviewModal, setReviewModal] = useState(false)

    const [ReviewdetailsModal, setReviewdetailsModal] = useState(false)
    const [ReviewSelected, setReviewSelected] = useState({})

    const [ReviewId, setReviewId] = useState(null)
    const [isFetching, setisFetching] = useState(false)





    const [Done, setDone] = useState(false)
    const [InputsErrors, setInputsErrors] = useState([])

    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    }


    useEffect(() => {
        getReviewsSelected()
    }, [Done])


    const getReviewsSelected = () => {
        fetch(`${apiUrl}/getReviewsSelected`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", 'Authorization': `Bearer ${UserToken}`
            },
            body: JSON.stringify({ user_id: userId })
        })
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    setReviewContent(result.data)
                }
            })
    }

    const getRatingInfo = (id) => {
        const review = ReviewContent.find(item => item.id == id)
        let total = 0
        review.ratings.map(item => {
            total += item.rating
        })

        return total / review.ratings.length
    }
    const ReviewDetails = (id) => {
        const review = ReviewContent.find(item => item.id == id)
        console.log('review', review)
        setReviewSelected(review)
        setReviewdetailsModal(true)
    }

    const deleteReview = async (id) => {
        setisFetching(true)
        fetch(`${apiUrl}/deleteReview`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", 'Authorization': `Bearer ${UserToken}`
            },
            body: JSON.stringify({ review_id: id })
        })
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    setDone(!Done)
                    setReviewdetailsModal(false)
                    setisFetching(false)
                    setReviewId(null)
                    toast.success(result.message, {
                        position: toast.POSITION.CENTER
                    });
                }
            })
        setisFetching(false)

    }

    return (
        <div>
            <button onClick={() => { setReviewModal(true) }} type="submit" className="w-full btn-edit">
                {t('Reviews Liste')}
            </button>

            {ReviewModal &&
                <div className='w-full'>
                    <div className="minscreen h-full overflow-y-auto animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-start inset-0 z-50 forms-info ">
                        <div className="absolute top-0 right-0 p-4">
                            <a className='w-12 h-12' onClick={() => { setReviewModal(false) }} >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                </svg>
                            </a>
                        </div>
                        <div className="w-full h-2/3 settingswidth grid  place-items-start p-8 ">
                            <div className="flex flex-col items-left justify-start ">
                                <p className="text-2xl text-gold mb-5 mt-5 font-bold">{t("Liste Reviews")}</p>
                            </div>

                            <div className='w-full flex pb-12 flex-col justify-center items-center gap-3'>
                                {
                                    ReviewContent.length > 0 ? (
                                        ReviewContent.map((review, index) => (
                                            <a onClick={() => { ReviewDetails(review.id) }} key={index} className={`relative w-full flex sections items-center  py-4 px-4 border border-transparent rounded shadow-sm text-sm font-medium font-semibold text-theme  h-16 hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold`} >
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 ml-3' : 'w-6 mr-3'}`}>
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                                                </svg>

                                                <div className='flex justify-between items-center w-full'>
                                                    <div className='grid'>
                                                        <p className='text-about truncate '>{review.firstName} {review.lastName}</p>
                                                        <p className='text-theme text-sm '>{formatDate(review.created_at)}</p>

                                                    </div>
                                                    <div className='flex justify-end items-center gap-1'>
                                                        <div className="flex items-center">
                                                            <svg className={`w-5 h-5 ${getRatingInfo(review.id) >= 1 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <svg className={`w-5 h-5 ${getRatingInfo(review.id) >= 2 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <svg className={`w-5 h-5 ${getRatingInfo(review.id) >= 3 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <svg className={`w-5 h-5 ${getRatingInfo(review.id) >= 4 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <svg className={`w-5 h-5 ${getRatingInfo(review.id) >= 5 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>


                                            </a>
                                        ))
                                    ) : (
                                        <div>
                                            <h2 className="text-2xl text-about mb-6">{t("Il n'y a aucun reviews.")}</h2>
                                        </div>
                                    )
                                }

                            </div>

                        </div>
                    </div>
                </div>
            }

            {ReviewdetailsModal &&
                <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
                    <div className="relative h-fit overflow-y-auto findservice  -mt-10 rounded-xl   sections">
                        <div className='px-3 ' >
                            <div className="flex flex-col items-left gap-1 justify-start ">
                                <p className="text-2xl text-gold mx-3 font-bold">{t("Name : ")} {ReviewSelected.firstName} {ReviewSelected.lastName}</p>
                                {ReviewSelected.entreprise &&
                                    <p className="text-2xl text-gold mx-3 font-bold">{t("Company : ")} {ReviewSelected.entreprise} </p>

                                }

                            </div>

                            <div className='overflow-y-auto h-80'>
                                {ReviewSelected.ratings.map((detail, index) => {
                                    if (detail.commet != null || detail.rating != 0) {
                                        return (
                                            <div key={index} className="cursor-pointer w-full grid place-items-start mt-2 py-4 px-4 border border-transparent rounded shadow-sm text-sm font-medium font-semibold text-theme div-sections   hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                                                <div className='w-full flex justify-between items-center'>
                                                    <div className='flex justify-start items-center gap-2'>
                                                        {detail.name}
                                                    </div>
                                                    <div className='flex justify-end items-center gap-1'>
                                                        <div className="flex items-center">
                                                            <svg className={`w-5 h-5 ${detail.rating >= 1 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <svg className={`w-5 h-5 ${detail.rating >= 2 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <svg className={`w-5 h-5 ${detail.rating >= 3 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <svg className={`w-5 h-5 ${detail.rating >= 4 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <svg className={`w-5 h-5 ${detail.rating >= 5 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='flex justify-start text-sm font-normal items-center '>
                                                    {detail.comment}
                                                </div>

                                            </div>
                                        )
                                    }
                                })

                                }
                            </div>


                            <div className="grid place-items-center grid-cols-2 gap-3 w-full px-3">
                                <button onClick={(e) => setReviewdetailsModal(false)} type="submit" className="m-3 hover:scale-1.1  mr-3 w-full btn-edit">


                                    {t("close")}
                                </button>
                                <button onClick={(e) => setReviewId(ReviewSelected.id)} type="submit" className="m-3  mr-3 w-full btn-edit">


                                    {t("delete")}
                                </button>
                            </div>



                        </div>



                    </div>
                </div>
            }
            {ReviewId &&
                <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
                    <div className="relative h-fit overflow-y-auto findservice  -mt-10 rounded-xl   sections">
                        <div className='px-3 ' >
                            <div className="flex  items-center justify-center ">
                                <p className="text-xl text-theme text-center m-3 font-normal">{t("are you sure you want to delete this Review!")} </p>
                            </div>


                            <div className="grid place-items-center grid-cols-2 gap-3 w-full px-3">
                                <button onClick={(e) => setReviewId(null)} type="submit" className="m-3 hover:scale-1.1  mr-3 w-full btn-edit">


                                    {t("annuler")}
                                </button>
                                <button onClick={(e) => deleteReview(ReviewId)} disabled={isFetching} type="submit" className="m-3  mr-3 w-full btn-edit">
                                    {isFetching ?
                                        (<svg class="w-4 h-4 text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none"
                                            xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                            <path
                                                d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                                                stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path
                                                d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                                                stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-900">
                                            </path>
                                        </svg>)
                                        : (
                                            t('valide')
                                        )
                                    }

                                </button>
                            </div>



                        </div>



                    </div>
                </div>
            }




        </div>
    )
}

export default ReviewDisplay